<template>
  <a class="text-decoration-none" :href="navigateUrl">
    <div class="row py-5">
      <div class="col-12 g-0">
          <h3 class="mb-0">{{podcast.Title}}</h3>
          <div class="d-flex flex-row podcast-card__info pb-2">
            <i class="fa-solid fa-calendar icon-light-gray"><span class="extra-small ms-2 me-5">{{date}}</span></i>
            <i class="fa-regular fa-clock icon-light-gray"><span class="extra-small ms-2 me-5">{{duration}}</span></i>
          </div>
          <p class="podcast-card__description">{{podcast.Description}}</p>
      </div>
    </div>
  </a>

</template>
<script>
  import moment from 'moment';

  export default {
    name: 'PodcastCard',
    props: {
      podcast: {
        type: Object,
        required: true
      }
    },
    setup(props) {
      var date = null;
      if (props.podcast.PublishedUtc) {
        date = moment(String(props.podcast.PublishedUtc)).format('MMMM DD, YYYY');
      }
      var duration = null;
      if (props.podcast.DurationSeconds) {
        var unformattedDuration = Math.round(props.podcast.DurationSeconds);
        if (unformattedDuration < 3600) {
          duration = new Date(unformattedDuration * 1000).toISOString().substr(14, 5);
        }
        else {
          duration = new Date(unformattedDuration * 1000).toISOString().substr(11, 8);
        }
      }
      var navigateUrl = null;
      if (props.podcast.Id) {
        navigateUrl = location.href + '/podcast-details/?clipId=' + props.podcast.Id;
      }
      return {
        date,
        duration,
        navigateUrl,
      };
    },
  };
</script>
